<swiper [config]="partnerSlides" #swiper>
    <ng-template swiperSlide *ngFor="let item of branches">
        <div class="single-partner-item">
            <a target="_blank" class="d-block">
                <img [src]="createImgPath(item?.logoImage)" style="max-width: 100px;" alt="image">
            </a>
        </div>
    </ng-template>
</swiper>